export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "viewer-assets-dir/js/worker.c1dc71ab.worker.js");
}
